import { render, staticRenderFns } from "./TranUserPackageActivityReminderCreateDetail.vue?vue&type=template&id=24447826"
import script from "./TranUserPackageActivityReminderCreateDetail.vue?vue&type=script&lang=js"
export * from "./TranUserPackageActivityReminderCreateDetail.vue?vue&type=script&lang=js"
import style0 from "./TranUserPackageActivityReminderCreateDetail.vue?vue&type=style&index=0&id=24447826&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports